import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document
	.querySelectorAll(".wp-block-weather-weather-forecast-prevision-city")
	.forEach((el) => {
		const root = el.querySelector(".weather-forecast-prevision-city__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
